<template>
  <div-box>
    <!-- <van-nav-bar title="地址管理" right-text="添加地址" left-arrow fixed :border="false" @click-left="back" @click-right="go('add_addres')" /> -->
    <!-- <div-navber title="地址管理"></div-navber> -->
    <wallet-head show_type="11" />
    <!-- 封装上拉下拉组件 坐标 vant-extend 文件 -->
    <vant-up-down ref="list" @list="(val) => (list = val)" res="res.data.data" url="/api/v1/memberAddress/list" data="">
      <div class="list">
        <div class="oneaddress" v-for="item in list" :key="item.id">
          <div class="info ">
            <div class="line">
              <div class="number">
                {{ item.is_default == 1 ? $t('默认') : "" }}
              </div>
              <div class="name">{{ item.name }}</div>
              <span>{{ item.mobile }}</span>
            </div>
            <div class="detail">
              {{ item.area.name_path }}
              {{ item.detail }}
            </div>
          </div>
          <div class="foot">
            <div class="edit" @click="router('edit_addres', item.id)">{{ $t('编辑') }}</div>
            <div class="del" @click="del(item.id)">{{ $t('删除') }}</div>
          </div>
        </div>
      </div>
    </vant-up-down>

    <div-foot>
      <div-padding padding="3vw">
        <div-btn @click.native="router('add_addres')" radius="3vw"
          bg="linear-gradient(270deg, #FFD791 0%, #F4BB67 100%)">
          <div-text color='#242424' blod size='4vw'>{{ $t('新增地址') }}</div-text>
        </div-btn>
      </div-padding>
    </div-foot>
  </div-box>
</template>

<script type="text/javascript">
export default {
  name: "app",
  data() {
    return {
      list: [],
    };
  },
  created() {
    // 滚动到顶部
    this.up_down()
  },
  methods: {
    del(id) {
      this.$dialog
        .confirm({
          title: this.$t('提示'),
          message: this.$t('确定要删除此地址吗?'),
          confirmButtonColor: "#333",
        })
        .then(() => {
          this.$delete({
            url: "/app/useraddress/index",
            data: { id: id },
            success: (res) => {
              this.$toast({
                message: this.$t('删除成功'),
                duration: 1000,
              });
              this.up_down()
            },
            tip: (val) => { },
          });
        })
        .catch(() => {
        });
    },
  },
};
</script>

<style scoped lang="less">
//地址列表样式
.list {
  width: 100%;

  .oneaddress {
    background: #1A1C1D;
    width: 92.53vw;
    box-shadow: 0vw 1.33vw 2.67vw 0vw rgba(0, 0, 0, 0.1);
    border-radius: 2.67vw;
    margin: 3.73vw auto;

    .foot {
      border-radius: 0 0 2vw 2vw;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 2vw 4vw;

      .edit {
        font-size: 2.67vw;
        color: #333;
        border-radius: 2vw 0 0 2vw;

        padding: 1vw 4vw;
        background: #f4bb67;
      }

      .del {
        font-size: 2.67vw;
        color: #fff;
        border-radius: 0 2vw 2vw 0;
        padding: 1vw 4vw;
        background: #453b2a;
      }
    }

    .info {
      flex: 1;
      padding: 0.5vw 4.28vw;

      .line {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin: 2.13vw 0;

        .name {
          font-size: 4vw;
          font-weight: bold;
          color: #fff;
          padding-right: 3vw;
        }

        .number {
          position: absolute;
          border-radius: 0 0 2vw 2vw;
          padding: 0 2vw;
          background: #f4bb67;
          right: 2vw;
          top: 0vw;
          font-size: 3.2vw;
          font-weight: 400;
          color: #333;
        }

        span {
          font-size: 3.5vw;
          font-weight: 400;
          color: #fff;
        }
      }

      .detail {
        font-size: 3.5vw;
        font-weight: 400;
        color: #fff;
        // padding-bottom: 4.35vw;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        margin-bottom: 2vw;
      }
    }
  }
}
</style>
